import { useEffect, useState } from 'react'

export const useTypewriter = (text: string, speed = 50, startDelay = 0) => {
  const [displayedText, setDisplayedText] = useState('')
  const [isComplete, setIsComplete] = useState(false)
  const [hasStarted, setHasStarted] = useState(false)

  useEffect(() => {
    if (!text) {
      setDisplayedText('')
      setIsComplete(false)
      setHasStarted(false)
      return
    }

    // Reset state when text changes
    setDisplayedText('')
    setIsComplete(false)
    setHasStarted(false)

    const startTimer = setTimeout(() => {
      setHasStarted(true)
      let currentIndex = 0

      const typeInterval = setInterval(() => {
        if (currentIndex < text.length) {
          setDisplayedText(text.slice(0, currentIndex + 1))
          currentIndex++
        } else {
          setIsComplete(true)
          clearInterval(typeInterval)
        }
      }, speed)

      return () => clearInterval(typeInterval)
    }, startDelay)

    return () => clearTimeout(startTimer)
  }, [text, speed, startDelay])

  return { displayedText, isComplete, hasStarted }
}

export const useWordTypewriter = (text: string, speed = 50, startDelay = 0) => {
  const [displayedText, setDisplayedText] = useState<string[]>([])
  const [isComplete, setIsComplete] = useState(false)
  const [hasStarted, setHasStarted] = useState(false)

  useEffect(() => {
    const startTimer = setTimeout(() => {
      setHasStarted(true)
      let currentIndex = 0
      const words = text.split(' ')
      const typeInterval = setInterval(() => {
        if (currentIndex < words.length) {
          setDisplayedText(words.slice(0, currentIndex + 1))
          currentIndex++
        } else {
          setIsComplete(true)
          clearInterval(typeInterval)
        }
      }, speed * 10)

      return () => clearInterval(typeInterval)
    }, startDelay)

    return () => clearTimeout(startTimer)
  }, [text, speed, startDelay])

  return { displayedText, isComplete, hasStarted }
}
